import { SurveyOption } from '@/types/enums/SurveyOption';
import React from 'react';
import SurveyQuestion from '../SurveyQuestion';

const EditSurvey = () => {
  return <SurveyQuestion option={SurveyOption.EDIT} />;
};

export default EditSurvey;
